import React from "react";

function CandidatePreferences() {
  return (
    <div className="p-8">
      <h1 className="text-h4 font-bold text-gray-900 mb-4">Preferences</h1>
      <p className="text-gray-600">Customize your notification and display preferences here.</p>
    </div>
  );
}

export default CandidatePreferences;
